import React, { useEffect, useState } from 'react';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import ApiServices from 'services/ApiServices';
import {PictureAsPdf} from '@material-ui/icons/';
import Form from 'components/Form/FormTwoColumns';
import {useStyles} from './style';
import { Container, Divider, Grid } from '@material-ui/core';
import { functions } from "constants/index";
import MostrarPDFModal from 'components/PdfModal'
import DialogLoadingMessage from 'components/LoadingMessage/index'
import { showMessagePersonalizedPosition } from 'services/SweetAlert';

const  FiltrosEstadisticasSolicitudes= (props)=> {
    const classes = useStyles(),
    [base64, setBase64] = useState(''),
    [abrirMostrarPDFModal, setAbrirMostrarPDFModal] = useState(false),
    [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});
    let description = [
        {name: "- Antes de continuar, revise que la información que ingresó esté correcta.",},
        {name: "- Datos requeridos (*)."}
    ],
        tiposDeSolicitudes = [
            {id: 0 , name: "TODOS"},
            {id: 1 , name: "INSCRIPCIÓN"},
            {id: 2 , name: "ACTUALIZACIÓN"},
            {id: 3 , name: "POSIBLE INSCRIPCIÓN"},
            {id: 4 , name: "POSIBLE ACTUALIZACIÓN"},
        ]

    const [elements,setElements] = React.useState({
        fechaInicio: { idelement: "fechaInicio", value: null, label: "Fecha de Inicio *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], errorMessages:['Ingrese fecha de inicio'], isError:false, elementType:'date' },
        fechaFin: { idelement: "fechaFin", value: null, label: "Fecha de Fin *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], errorMessages:['Ingrese fecha fin'], isError:false, elementType:'date' },
        tipoSolicitud: { idelement: "tipoSolicitud", value:'' , label: "Tipo de Solicitud *", pattern:"^[0-9-][0-9]*$", validators: ['required'], errorMessages:['Seleccione tipo de solicitud'], isError:false, elementType:'autocomplete', list: tiposDeSolicitudes,},
    });

    const CerrarMostrarPDFModal = () => {
        setAbrirMostrarPDFModal(false)
    }
    const GenerarReporteEstadisticasSolicitudes = async () => {
        setLoadingMessage({loading:true, title: 'Generando reporte. Espere un momento ...'})
        var saveData = {
            usermod: props.currentUser.userName,
            fechaInicio: elements.fechaInicio.value,            
            fechaFin: elements.fechaFin.value,            
            tipoSolicitud: String(elements.tipoSolicitud.value),            
        };
        try {
            let response = await ApiServices.estadisticasSolicitudes.reporteEstadisticasSolicitud(saveData)
            if(response.error!==null){
                showMessagePersonalizedPosition('warning', '¡Oops! ' ,response.error.message, 'center')
            }
            else{
                setBase64(response.data)
                setAbrirMostrarPDFModal(true)
            }
        } catch (exception) {
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }                 
        }  
        setLoadingMessage({loading:false, title: ''})
    };
    const DescargarPDF = () => {
        elements.tipoSolicitud.value === 1 ? functions.downloadPDFFromStringBase64(base64, 'Reporte de Estadísticas de solicitudes de Inscripción.pdf') : 
        elements.tipoSolicitud.value === 2 ? functions.downloadPDFFromStringBase64(base64, 'Reporte de Estadísticas de solicitudes de Actualización.pdf') : 
        functions.downloadPDFFromStringBase64(base64, 'Reporte de Estadísticas de solicitudes para General.pdf');
    }

    const [buttonList,setButtonList]= React.useState({
        "next":{"label":"Generar y mostrar reporte en PDF","icon": <PictureAsPdf />,"callback":GenerarReporteEstadisticasSolicitudes,"loading":false,"size":"medium","color":"#fff", "background":"linear-gradient(130deg, rgb(6, 107, 189) 30%, rgb(30, 136, 229) 90%) repeat scroll 0% 0% ",},   
    });

    return (
        <div >
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <br/>
            <Container maxWidth="lg">        
            <Grid container >
                <div className={classes.colorComponente} >
                    <Grid item xs={12}>
                        <div className={classes.centerTitle}><Divider /> <strong>Complete los campos</strong> <Divider /></div>
                    </Grid >                    
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                        <Form   elements= {elements}  buttonList={buttonList} description={description}/>
                    </Grid>
                    <div className={classes.lineaDegradadaBottom}></div>
                </div>
            </Grid>
            <MostrarPDFModal open={abrirMostrarPDFModal} handleClose={CerrarMostrarPDFModal} 
                title={
                    elements.tipoSolicitud.value === 1 ? 'REPORTE DE ESTADÍSTICA DE SOLICITUDES DE INSCRIPCIÓN' :
                    elements.tipoSolicitud.value === 2 ? 'REPORTE DE ESTADÍSTICA DE SOLICITUDES DE ACTUALIZACIÓN' : 'REPORTE DE ESTADÍSTICA DE SOLICITUDES GENERAL'
                }
                base64={base64} DescargarPDF={DescargarPDF}
            />
            </Container>
        </div>
    );   
}
export default connect(mapStateToProps, mapDispatchToProps)(FiltrosEstadisticasSolicitudes);